import React, { Fragment, PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultRowCell } from "../../../Layout/SortedList";
import { formatQuantityValue } from "../../../../helpers/unitOfMeasurementHelpers";

class RollsListRowTotals extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    paginatedData: PropTypes.array
  };

  static defaultProps = {
    isMobile: false,
    paginatedData: []
  };

  render() {
    const { isMobile, paginatedData } = this.props;
    const [firstItem = {}] = paginatedData;
    const { grossWeight = {} } = firstItem;
    const quantity = { value: _.sumBy(paginatedData, item => parseFloat(item.grossWeight.value)), unitOfMeasurement: grossWeight.unitOfMeasurement };

    return (
      <div role="row" tabIndex="0" className="sorted-list__row">
        {isMobile ? (
          <Fragment>
            <DefaultRowCell className="--totals" value={i18n.t("billsOfLading.totals")} />
            <DefaultRowCell className="--totals" header={i18n.t("rolls.shipped")} value={formatQuantityValue(quantity)} />
            <DefaultRowCell className="--totals" header={i18n.t("rolls.rp")} value={String(_.sumBy(paginatedData, "rollsPerPack"))} />
          </Fragment>
        ) : (
          <Fragment>
            <DefaultRowCell className="--totals --first --x3" value={i18n.t("billsOfLading.totals")} />
            <DefaultRowCell className="--totals --x7" />
            <DefaultRowCell className="--totals --right --x2" value={formatQuantityValue(quantity)} />
            <DefaultRowCell className="--totals --right --x4" />
            <DefaultRowCell className="--totals --right --x1" value={String(_.sumBy(paginatedData, "rollsPerPack"))} />
            <DefaultRowCell className="--totals --x3" />
          </Fragment>
        )}
      </div>
    );
  }
}

export default RollsListRowTotals;



// WEBPACK FOOTER //
// ./src/components/BillOfLading/List/Rolls/RollsListRowTotals.js